import { defineMessages } from "react-intl";

export const SelectLinkedRecordModalHeaderText = defineMessages({
  searchPlaceholder: {
    defaultMessage: "Find an existing record",
    id: "RjaR1L",
  },
});
